import React, { forwardRef, useState } from 'react';
import { ActivityIndicator, Pressable, StyleSheet, View } from 'react-native';
import Text from '@/components/Typography/Text';
import IdeaGroup from './IdeaGroup';

// Shared desktop feed. Data fetching and navigation belong to the caller.
export default forwardRef(function DiscoveryFeedLayout({ palette, items, loading, error, retryBlocked, loaded, cursor,
  onLoadMore, onSelect, onSeen, renderFeature, children, testID = 'home-discovery-feed' }, ref) {
  const [contentWidth, setContentWidth] = useState(0);
  const columns = contentWidth >= 850 ? 3 : contentWidth >= 510 ? 2 : 1;
  const cardWidth = contentWidth ? (contentWidth - (columns - 1) * 14) / columns : '100%';
  const button = label => <Pressable accessibilityRole="button" accessibilityLabel={label} onPress={onLoadMore} style={styles.action}><Text size="xs" color="secondary">{label}</Text></Pressable>;
  return <View ref={ref} style={[styles.root, { borderTopColor: palette.border }]} testID={testID}>
    <View style={styles.header}><Text accessibilityRole="header" size="xl" weight="semibold">For you</Text></View>
    {children}
    <View onLayout={event => setContentWidth(event.nativeEvent.layout.width)} style={styles.grid}>
      {Array.from({ length: Math.ceil(items.length / 6) }, (_, group) => {
        const rows = items.slice(group * 6, group * 6 + 6);
        return <React.Fragment key={group}>
          <IdeaGroup items={rows} groupIndex={group} width={contentWidth} palette={palette} onSeen={onSeen} onSelect={onSelect} />
          {rows.length === 6 && renderFeature?.({ group, items: rows, columns, cardWidth })}
        </React.Fragment>;
      })}
    </View>
    {loading && <View style={styles.footer} accessibilityLiveRegion="polite"><ActivityIndicator color={palette.icon} /><Text size="s" color="secondary">Finding more ideas…</Text></View>}
    {!!error && <View style={styles.footer}><Text size="s" color="secondary" accessibilityLiveRegion="polite">{error}</Text>{!retryBlocked && button('Try again')}</View>}
    {loaded && !loading && !error && !cursor && <Text style={styles.footer} size="s" color="secondary">{items.length ? 'You’re caught up. Come back later for fresh ideas.' : 'No ideas to show right now. Please try again later.'}</Text>}
    {loaded && !loading && !error && !!cursor && button('More ideas')}
  </View>;
});
const styles = StyleSheet.create({
  root: { width: '100%', maxWidth: 1080, alignSelf: 'center', borderTopWidth: StyleSheet.hairlineWidth, paddingTop: 24, paddingHorizontal: 20, paddingBottom: 36 },
  header: { flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: 12, marginBottom: 20 },
  grid: { flexDirection: 'row', flexWrap: 'wrap', gap: 14 },
  action: { minHeight: 36, paddingHorizontal: 10, paddingVertical: 8, borderRadius: 9, flexDirection: 'row', alignItems: 'center', justifyContent: 'center', gap: 7 },
  footer: { paddingVertical: 28, alignItems: 'center', textAlign: 'center', gap: 10 },
});
